﻿﻿export interface IWorkflowStatus {
    rank: number;
    id: number;
    centerId: number;
    sortOrder: number;
    description: string;
    associatedDisposition: number;
    isInEmr: boolean;
    isILDA: boolean;
    addFollowUp: boolean;
    isRuledOut: boolean;
}
